/**
 * The micro-label layer.
 *
 * These pages load no webfont (see src/index.css), so the type system has to
 * earn its character from having three genuinely distinct roles rather than
 * from three bought faces. This is the third one: small, letterspaced, upper
 * case, used for every label that names a thing rather than saying something —
 * the masthead's "Checkout", the "Secure" mark, each ledger row's key, the
 * footer's processor line.
 *
 * A shared constant rather than a component: it is applied to spans, anchors
 * and `<dt>`s alike, and wrapping each of those in a wrapper element to carry
 * four utilities would cost more than it saved.
 */
export const MICRO_CAPS =
  "text-[0.6875rem] leading-none font-medium tracking-[0.16em] uppercase";
